<style scoped>
.br-10 {
  border-radius: 10px;
}
.ellipsis {
  white-space: nowrap;
  width: 250px;
  text-overflow: ellipsis;
}
</style>

<template>
  <v-container fluid>
    <span class="text-caption" v-if="loading">{{ $t('searching') }}</span>
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <br v-if="loading"/>

    <v-alert v-if="error" id="error" :value="error !== null" class="br-10 dark font-weight-medium" type="error" dismissible>{{ error.message | uppercase }}</v-alert>
    <!-- <v-layout justify-center class="pb-3" style="cursor: pointer;">
      <v-flex xl6 lg6 md8 sm10 xs12  v-if="hasSession && hasLicenseAdminRole">
        <v-list two-line class="br-10 elevation-3 indigo lighten-4 blue-grey--text text--darken-3" color="blue" @click.native="$router.push('/trading/list')">
          <v-list-item>
            <v-list-item-action>
              <img width="50" height="50" src="img/cards/checked.png">
            </v-list-item-action>
            <v-list-item-content class="pl-2">
              <v-card class="elevation-0 transparent font-weight-medium" style="font-size: 18px;">Senarai Permohonan Lesen Berniaga (Office Use Only)</v-card>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-flex>
    </v-layout> -->
    <v-layout justify-center class="pb-3">
      <v-flex xl6 lg6 md8 sm10 xs12 >
        <v-list two-line class="br-10 elevation-3 pink lighten-4 blue-grey--text text--darken-3" color="blue" @click.native="$router.push('/trading/form')" style="cursor: pointer;">
          <v-list-item>
            <v-list-item-action>
              <img width="50" height="50" src="img/cards/checked.png">
            </v-list-item-action>
            <v-list-item-content class="pl-2">
              <v-card class="elevation-0 transparent font-weight-medium" style="font-size: 18px;">{{ $t('license_application_trading') }}</v-card>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-flex>
    </v-layout>
    <v-layout justify-center class="pb-3">
      <v-flex xl6 lg6 md8 sm10 xs12>
          <v-card color="blue lighten-4" class="br-10 elevation-3">
            <v-list two-line class="br-10 elevation-0 lighten-4 black--text" color="blue" @click.native="menu2 = !menu2" style="cursor: pointer;">
              <v-list-item>
                <v-list-item-action>
                  <img width="50" height="50" src="img/cards/checked.png">
                </v-list-item-action>
                <v-list-item-content class="pl-2">
                  <v-card class="elevation-0 transparent font-weight-medium" style="font-size: 18px;">{{ $t('page_license.index.header3', { type: $t('page_license.trading') }) }}</v-card>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon style="font-size: 20px;" v-if="!menu1" color="primary">fa-chevron-circle-down</v-icon>
                  <v-icon style="font-size: 20px;" v-if="menu1" color="primary">fa-chevron-circle-up</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-form v-if="menu2" @submit.prevent="searchTradingApplication()">
              <v-divider></v-divider>
              <div class="pa-3 pr-4 pl-4">
                <v-text-field :value="form.id" @input="setForm({ form: { id: $event} })" :label="$t('reference_no')"/>
                <v-layout reverse row class="mt-2 pa-5">
                  <v-btn :disabled="!form.id" color="primary" large rounded type="submit">{{ $t('page_license.index.search') }}</v-btn>
                </v-layout>
              </div>
            </v-form>
          </v-card>
        </v-flex>
    </v-layout>
    <v-layout justify-center class="pb-3">
      <v-flex xl6 lg6 md8 sm10 xs12>
          <v-card color="blue lighten-4" class="br-10 elevation-3">
            <v-list two-line class="br-10 elevation-0 blue lighten-4 black--text" color="blue" @click.native="menu1 = !menu1">
              <v-list-item>
                <v-list-item-action>
                  <div style="max-height: 50px">
                    <img width="50" height="50" src="img/cards/checked.png">
                  </div>
                </v-list-item-action>
                <v-list-item-content class="pl-2">
                  <v-card class="elevation-0 transparent font-weight-medium" style="font-size: 18px;">{{ $t('page_license.index.header2') }}</v-card>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon style="font-size: 20px;" v-if="!menu1" color="primary">fa-chevron-circle-down</v-icon>
                  <v-icon style="font-size: 20px;" v-if="menu1" color="primary">fa-chevron-circle-up</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-form v-if="menu1" @submit.prevent="searchData()">
              <v-divider></v-divider>
              <div class="pa-3 pr-4 pl-4">
                <v-text-field :value="data.trading_no" @input="patchData({ searchId: $event })" :label="$t('searches')"/>
                <span class="caption"><strong>{{ $t('page_license.index.hint2') }}</strong></span><br>
                <!-- <v-text-field :value="data.ic_no" @input="patchData({ ic_no: $event })" :label="`${$t('ic_no')} / No ${$t('passport')} / ${$t('old_ic')}`"/> -->
                <v-layout reverse row class="mt-2 pa-5">
                  <v-btn :disabled="!data.searchId || data.searchId.length === 0" color="primary" large rounded type="submit">{{ $t('page_license.index.search') }}</v-btn>
                  <!-- <v-btn :disabled="data === {} || !data.trading_no || !data.ic_no" color="primary" large rounded type="submit">{{ $t('page_license.index.search') }}</v-btn> -->
                </v-layout>
              </div>
            </v-form>
          </v-card>
        </v-flex>
    </v-layout>
    <!-- <v-layout justify-center v-if="listData.length > 0">
      <v-flex xl6 lg6 md8 sm10 xs12>
        <v-list three-line class="br-10 elevation-3">
          <v-subheader class="black--text"><h3>{{ $t('page_license.index.result') }} ({{listData.length}})</h3></v-subheader>
          <v-divider/>
          <div v-for="item in listData" :key="item._id">
            <v-list-item style="cursor: pointer;">
              <v-list-item-action class="pl-2">
                <v-checkbox :value="item.account_reference" :input-value="data._id" @click.native="setData({ data: { _id: item.account_reference, type: item.account_module } })"/>
              </v-list-item-action>
              <v-list-item-content @click.stop="setData({ data: { _id: item.account_reference, type: item.account_module } })">
                <v-list-item-title class="body-2"><strong>{{ $t('page_license.index.license_permit_no2') }} : {{ item.info.license_no }}</strong></v-list-item-title>
                <v-list-item-subtitle class="ellipsis"><h4>{{ $t('page_license.index.name') }} : {{ item.info.business_name && item.info.business_name.replace(/-/g, '').length > 0 ? hideText(item.info.business_name) : hideText(item.info.owners[0].name) | capitalize }}</h4></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
          <v-layout reverse row class="pa-4">
            <v-btn :disabled="data._id === undefined || data._id === ''" @click="redirect()" class="mt-3" color="primary" large nuxt align-right rounded>{{ $t('page_assessment.index.proceed') }}</v-btn>
          </v-layout>
        </v-list>
      </v-flex>
    </v-layout> -->
    <v-layout justify-center v-if="listData.length > 0">
      <v-flex xl6 lg6 md8 sm10 xs12>
        <v-list three-line class="br-10 elevation-3">
          <v-subheader class="black--text"><h3>{{ $t('page_license.index.result') }}</h3></v-subheader>
          <v-divider/>
          <div v-for="item in listData" :key="item.info.license_no">
            <v-list-item style="cursor: pointer;" ripple>
              <v-list-item-action class="pl-2">
                <v-checkbox :value="item.account_reference" :input-value="data._id" @click.native="setData({ data: { _id: item.account_reference, type: item.account_module } })"/>
              </v-list-item-action>
              <v-list-item-content @click.stop="setData({ data: { _id: item.account_reference, type: item.account_module } })">
                <v-list-item-title class="body-2"><strong>{{ $t('page_license.index.license_permit_no2') }} : {{ item.info.license_no }}</strong></v-list-item-title>
                <v-list-item-subtitle class="ellipsis"><h4>{{ $t('business_name') }} : {{ hideText(item.info.business_name) | capitalize }}</h4></v-list-item-subtitle>
                <v-list-item-subtitle><h4>{{ $t('owner_name') }} : {{ hideText(item.info.recipient) | capitalize }}</h4></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
          <v-layout reverse row class="pr-5 pa-5">
            <v-btn :disabled="data._id === undefined || data._id === ''" @click="redirect()" class="mt-3" color="primary" large nuxt align-right rounded>{{ $t('page_assessment.index.proceed') }}</v-btn>
          </v-layout>
        </v-list>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import vuex from 'vuex'

export default {
  beforeDestroy () {
    this.$store.commit('search/setError', { error: null })
    this.$store.commit('search/setLoading', { loading: false })
  },
  computed: {
    ...vuex.mapState({
      user: (state) => state.auth.data,
      data: state => state.search.data,
      form: state => state.search.form,
      loading: state => state.search.loading,
      error: state => state.search.error,
      listData: state => state.search.listData
    }),
    ...vuex.mapGetters({
      hasSession: 'auth/hasSession',
      hasLicenseAdminRole: 'auth/hasLicenseAdminRole'
    })
  },
  data () {
    return {
      menu1: true,
      menu2: false
    }
  },
  beforeMount () {
    this.$store.commit('search/setListData', { listData: [] })
  },
  created: function () {
    const { renewal } = this.$route.query
    this.$store.dispatch('auth/session')
    if (renewal && renewal === 'true') {
      this.menu2 = false
      this.menu1 = true
    }
  },
  methods: {
    ...vuex.mapActions({
      patchData: 'search/patchData',
      resetData: 'search/resetData',
      searchData: 'search/searchData',
      searchID: 'search/searchID'
    }),
    ...vuex.mapMutations({
      setData: 'search/setData',
      setForm: 'search/setForm'
    }),
    redirect () {
      return this.$router.push({ name: 'trading-id', params: { id: btoa(this.data._id) }, query: { type: 'license_trading' } })
    },
    searchTradingApplication: async function ($event) {
      const response = await this.searchID()
      if (response) {
        this.$router.push(`/trading/preview/${response._id}`)
        this.setForm({ form: { id: '' } })
      }
      await this.resetData()
    },
    hideText (text) {
      var t = text || ''
      var hiddenText = ''
      for (var i = 0; i < t.length; i++) {
        if (i > 4) {
          hiddenText += '*'
        } else {
          hiddenText += t[i]
        }
      }
      return hiddenText
    }
  }
}
</script>
